// import React from "react";
// import { useLicense } from "../GetData/Context/LicenseContext";

// export default function LicenseBanner() {
//   const { licenseInfo } = useLicense();

//   if (!licenseInfo) return null;

//   if (licenseInfo.status !== "ExpiringSoon") return null;
//   console.log(licenseInfo.status);

//   return (
//     <div className="license-banner">
//         <p>1</p>
//       ⚠️ Licenca juaj skadon për{" "}
//       <strong>{licenseInfo.daysLeft} ditë</strong>.
//       Ju lutemi kontaktoni për rinovim.
//     </div>
//   );
// }

import axios from "axios";
import React, { useEffect, useState } from "react";
import { ApiLink } from "../APILink/ApiLink";
import { errorAlert } from "./Alerts";
import authHeader from "../Auth/authHeader";
// import { getLicenseStatus } from "../services/licenseService";

export default function LicenseBanner() {
  const [license, setLicense] = useState(null);
  const headers = authHeader();
  const getCompanyLicenseStatus = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "LicenseStatus/status",
        {
          headers,
        }
      );
      // setCompanyID(response.data[0].CompanyID);
      setLicense(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);
      setLicense(null);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  useEffect(() => {
    getCompanyLicenseStatus();
  }, []);

  if (!license) return null;

  if (license.Status !== "ExpiringSoon") return null;

  return (
    <div className="license-banner" role="status" aria-live="polite">
      <span className="license-banner__icon" aria-hidden="true">
        !
      </span>
      <span className="license-banner__message">{license.Message}</span>
      <a
        className="license-banner__cta"
        href="https://acctree.net/pricing/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Per ri-licensim, shihni paketat
      </a>
    </div>
  );
}
